import React, { useEffect, useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography, Autocomplete } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PlusCircle, ArrowLeft, ChevronLeft, User } from 'react-feather';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast';

const RequiredLabel = ({ children }) => (
    <>
      {children} <span style={{ color: 'red' }}>*</span>
    </>
  );

export default function CreateFamily() {
    const [clientname, setClientName] = useState(null);
    const [estatename, setEstateName] = useState(null);
    const [familyname, setFamilyname] = useState('');
    const [username, setUserName] = useState([]); // Initialize as an empty array
    const [active, setActive] = useState(true);
    const [errors, setErrors] = useState({}); // State to hold validation errors
    const [clientNameOptions, setClientNameOptions] = useState([])
    const [estateOptions, setEstateOptions] = useState([])
    const [userNameOptions, setUserNameOptions] = useState([])
      const [isLoading, setIsloading] = useState(false);

    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        fetchClient();
       
        fetchUsers();
    }, [token, userID]);

    useEffect(()=>{
        if(clientname){
            fetchEstate(clientname)
        }

    },[clientname])

    const fetchEstate= async (clientname) => {
        const input_token = 'ESTATE_DROP_DOWN';
        const apiUrl = 'list_of_estates_dropdown';

        const dataInput = {
            login_user_id: userID,
            client_id:clientname.id
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data) {
                setEstateOptions(data.estate_list);

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');

            } else if (data === undefined) {
                await Toastmessage('No response from server', false);

            } else {
                await Toastmessage(data?.message || 'An error occurred', false);

            }
        } catch (error) {

        }

    }

    const fetchClient = async () => {
        const input_token = 'CLIENTS';
        const apiUrl = 'list_of_clients';

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data) {
                setClientNameOptions(data.client_list);

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');

            } else if (data === undefined) {
                await Toastmessage('No response from server', false);

            } else {
                await Toastmessage(data?.message || 'An error occurred', false);

            }
        } catch (error) {

        }

    }


    const fetchUsers = async () => {
        const input_token = 'ALL_USERS';
        const apiUrl = 'list_of_firm_users';

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data) {
                setUserNameOptions(data.clients);

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');

            } else if (data === undefined) {
                await Toastmessage('No response from server', false);

            } else {
                await Toastmessage(data?.message || 'An error occurred', false);

            }
        } catch (error) {

        }

    }

    const handleActiveChange = (event) => {
        setActive(event.target.checked);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!familyname.trim()) {
            newErrors.familyname = "Family name is required";
        }

        if (!clientname) {
            newErrors.clientname = "Client name is required";
        }

        if (!estatename) {
            newErrors.estatename = "Estate name is required";
        }

        // Check if the array is empty for the multi-select dropdown
        if (username.length === 0) {
            newErrors.username = "Username is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Exit if validation fails
        }

        const addFamilytreeApi = async () => {
            setIsloading(true)
            const input_token = 'CREATE_FAMILYTREE' + familyname;
            const apiUrl = 'create_family_tree';
            const formData = {
                login_user_id: userID,
                family_name: familyname,
                client_id: clientname?.id,
                estate_id:estatename?.id,
                status: active ? 1 : 0,
                users: username.map((user) => user.id), // Extract the names of the selected users
            };

            try {
                const data = await authApi(input_token, formData, apiUrl, token, true);
                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false)
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false)
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false)
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false)
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addFamilytreeApi();


    };

    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add New FamilyTree
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/familytree"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to FamilyTree List
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>

                <form onSubmit={handleSubmit}>
                    <Box className="sub-header">
                        <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                            <Link to="/familytree" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} /> {/* Add margin for spacing */}
                                Add New Family Name
                            </Link>
                        </Typography>
                        <FormControlLabel
                            control={<Switch checked={active} onChange={handleActiveChange} />}
                            label={
                                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                    Active : {active ? 'Yes' : 'No'}
                                </Typography>
                            }
                        />
                    </Box>
                    <Grid container spacing={4} sx={{ mt: 2 }}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Family Name</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the family name"
                                variant="outlined"
                                value={familyname}
                                onChange={(e) => setFamilyname(e.target.value)}
                                error={!!errors.familyname}
                                helperText={errors.familyname} // Display error message
                                InputProps={{
                                    sx: {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select Client</RequiredLabel></Typography>
                            <Autocomplete
                                options={clientNameOptions}
                                getOptionLabel={(option) => option.full_name}
                                value={clientname}
                                onChange={(event, newValue) => setClientName(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select client"
                                        variant="outlined"
                                        error={!!errors.clientname}
                                        helperText={errors.clientname} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select Estate</RequiredLabel></Typography>
                            <Autocomplete
                                options={estateOptions}
                                getOptionLabel={(option) => option.estate_name}
                                value={estatename}
                                onChange={(event, newValue) => setEstateName(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Estate"
                                        variant="outlined"
                                        error={!!errors.estatename}
                                        helperText={errors.estatename} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select User</RequiredLabel></Typography>
                            <Autocomplete
                                multiple // Enable multi-select
                                options={userNameOptions}
                                getOptionLabel={(option) => option.full_name}
                                value={username} // Ensure this is always an array of selected options
                                onChange={(event, newValue) => setUserName(newValue)} // Ensure this updates the username state
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Users"
                                        variant="outlined"
                                        error={!!errors.username}
                                        helperText={errors.username} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                startIcon={<PlusCircle size={20} />}
                                disabled={isLoading}
                                className='btn-theme-button'
                            >
                                Add New Family Name
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>

        </Box>
    );
}
